<script>
export default {
    name: "wrapper",
    data() {
        return {};
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <router-view></router-view>
</template>

<style scoped lang="scss">
.wrapper{
    
}
</style>